import * as React from "react"
import {Icon, Table} from "semantic-ui-react"
import {CommonPlace} from "../model/places/PlaceTypes"

interface Props {
  commonPlace: CommonPlace
  index: number
  selected: boolean
  onSelect: (index: number) => void
  onDelete: (index: number) => void
}

export class CommonPlaceRow extends React.Component<Props, {}> {
  handleSelect = () => this.props.onSelect(this.props.index)

  handleDelete = () => this.props.onDelete(this.props.index)

  render() {
    const {
      commonPlace: {label, locale, category, suggest},
      selected,
    } = this.props

    return (
      <Table.Row onClick={this.handleSelect} active={selected}>
        <Table.Cell singleLine>{locale.label}</Table.Cell>
        <Table.Cell singleLine>{label}</Table.Cell>
        <Table.Cell singleLine>{category}</Table.Cell>
        <Table.Cell singleLine>{suggest && <Icon name="checkmark" color="green" />}</Table.Cell>
        <Table.Cell singleLine>
          <Icon link={true} onClick={this.handleDelete} name="close" color="grey" />
        </Table.Cell>
      </Table.Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CommonPlaceRow.tsx